import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=7c4a3944&lang=pug&"
import script from "./user-dropdown.vue?vue&type=script&lang=js&"
export * from "./user-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports